<template>

    <div class="progressbar-cont">
        <div class="bar-cont">
            <div class="prog-bar" ref="outer" @click.prevent="setPosition($event)">
                <div class="bar bar-outer">
                    <div class="bar bar-inner" ref="progbar" :style="{width: progress}"></div>
                    <div class="pointer" :style="{left:mousePos}"></div>
                </div>
            </div>
        </div>
        <div class="time-cont">
            {{timeStr}}
        </div>
    </div>


</template>

<script>
    export default {
        name: 'ProgressBar',
        props: ['me', 'post'],
        data() {
            return {
                position: 0,
                mpos: 50,
                timeStr: "0:00"
            }
        },
        computed:{
            progress(){
                return this.position+"%"
            },
            mousePos(){
                return this.mpos+"px";
            }
        },
        mounted() {
            setTimeout(()=>{
                this.me.onloadstart = ()=>{this.init()};
                this.me.onloadedmetadata = this.loadedMeta;
                this.me.ontimeupdate = (e)=>{this.calcProg()};
                this.me.onwaiting = (e)=>{this.$bus.$emit('loading', 'posts.getVideoUrl')};
                this.me.onplaying = (e)=>{this.$bus.$emit('loaded', 'posts.getVideoUrl')};
                this.$refs['outer'].onmousemove = (e)=>{this.mpos = this.getXpos(e)};
            },5);
        },
        methods: {
            init(){
                this.timeStr='0:00';
                if(this.me.duration){
                    this.timeStr = this.secToTime(this.me.currentTime) + " / " + this.secToTime(this.me.duration);
                }
            },
            calcProg(){
                let prog = 0;
                if(this.me.duration){
                    prog = this.me.currentTime / this.me.duration * 100;
                    this.timeStr = this.secToTime(this.me.currentTime) + " / " + this.secToTime(this.me.duration);
                }
                this.$bus.$emit('player.progress', {progress: prog, time: this.timeStr});
                this.position = prog;
            },
            setPosition(event){
                const pos  = this.getXpos(event);
                const perc = pos /  this.$refs['outer'].offsetWidth;
                this.me.currentTime = Math.round(perc * this.me.duration);

            },
            getXpos(event){
                return event.clientX - this.$refs['outer'].offsetLeft;
            },
            secToTime(secs){
                let d = new Date(0);
                d.setSeconds(secs);
                return d.getMinutes()+":"+this.nStr(d.getSeconds())
            },
            nStr(val){
                let str = val.toString();
                if(str.length < 2) str = "0"+str;
                return str;
            },
            loadedMeta(e){
                this.init();
                if(this.post.post.duration == 0){
                    const newDur = Math.round(this.me.duration);
                    this.$api.updatePostDuration(this.post.post._id, newDur)
                        .then((res)=>{
                            this.post.post.duration = newDur;
                        })

                }

            }

        }
    }
</script>

<style lang="sass" scoped>
    .progressbar-cont
        display: table
        width: 100%

    .bar-cont, .time-cont
        display: table-cell

    .bar-cont


    .time-cont
        color: #FFF
        width: 120px
        padding-left: 10px

</style>



// WEBPACK FOOTER //
// src/components/player/ProgressBar.vue